import React from "react";
import Popup from "reactjs-popup";

import emptyImage from "../../assets/images/emptyAvatar.svg";
import { cn } from "../../utils/utils";

const ImageContainer = ({ src, width, height, className }) => {
  return (
    <div>
      <>
        <Popup
          trigger={
            <img
              src={src ? src : emptyImage}
              alt="pic"
              className={cn("", className)}
              width={width}
              height={height}
              style={{ minHeight: height }}
            />
          }
          modal
        >
          {(close) => (
            <div className="w-full bg-neutral-10 mb-5 rounded-v-lg p-4 flex flex-col shadow-xl" dir="ltr">
              <img src={src} alt="pic" className="max-w-[50vw] max-h-[75vh]" />
              <hr />

              {/* Use <a> tag to trigger the download */}
              <a href={src} download className="border-none ring-none  outline-none">
                <button className=" mt-4 px-4 py-2 bg-dark  hover:bg-slate-600 text-white rounded">
                  دانلود فایل
                </button>
              </a>
            </div>
          )}
        </Popup>
      </>
    </div>
  );
};

export default ImageContainer;
